export const FETCH_USER_SUMMARY_AVERAGES = 'FETCH_USER_SUMMARY_AVERAGES';
export const FETCH_USER_SUMMARY_AVERAGES_FETCHING = 'FETCH_USER_SUMMARY_AVERAGES_FETCHING';
export const FETCH_USER_SUMMARY_AVERAGES_SUCCESS = 'FETCH_USER_SUMMARY_AVERAGES_SUCCESS';
export const FETCH_USER_SUMMARY_AVERAGES_FAIL = 'FETCH_USER_SUMMARY_AVERAGES_FAIL';

export function fetchUserSummaryAverages(payload) {
    return {
        type: FETCH_USER_SUMMARY_AVERAGES,
        payload
    };
}
